import React, { FC, useEffect } from 'react';
import { FullCalendar } from './ui/fullCalendar/FullCalendar';
import * as S from './styles';
const ReservedTablesPage: FC = () => {
    return (
        <S.Wrapper>
            <S.Title>Забронированные столы</S.Title>
            <FullCalendar />
        </S.Wrapper>
    );
};
export default ReservedTablesPage;
